const faqAccordion = () => {
  //FAQ accordion
  let faqRows = document.querySelectorAll('.faq-row');
  const moreQuestionsBtn = document.querySelector('.more-questions-button');

  if (faqRows.length > 0) {
    if (faqRows.length < 5) {
      moreQuestionsBtn.style.display = 'none';
    }
    faqRows.forEach((item) => {
      item.addEventListener('click', (event) => {
        item.classList.toggle('open-faq');
      });
    });

    //FAQ more
    if (moreQuestionsBtn) {
      moreQuestionsBtn.addEventListener('click', (event) => {
        event.preventDefault();
        moreQuestionsBtn.style.display = 'none';
        document
          .querySelector('#faqs .module.partial-faq')
          .classList.remove('partial-faq');
      });
    }
  }
};

export { faqAccordion };
